export enum Subject {
  Math = 'Math',
  Language = 'Language',
  Science = 'Science',
  Reading = 'Reading'
}
